<!-- Header -->
<div class="px-3 pt-2 pb-3">
  <div class="card-header-grid">
    <!-- Search -->
    <div class="input-group input-lined" role="search">
      <div class="input-group-text">
        <i role="img" class="fa fa-search text-muted" aria-hidden="true"></i>
      </div>
      <input
        [(ngModel)]="filterTerm"
        class="form-control"
        placeholder="{{ 'general.search' | translate }}"
        attr.aria-label="{{ 'general.search' | translate }}"
        type="search"
        (ngModelChange)="onSearch($event)"
      />
    </div>
    <!-- End Search -->

    <div
      class="spinner-border"
      role="status"
      attr.aria-label="{{ 'general.loading' | translate }}"
      *ngIf="isLoading"
    >
    </div>

    <div class="d-flex justify-content-end align-items-center">
      <div>
        <span>
          {{
            (
              tableData
              | getSaleTableData: selectedSaleIds : selectedFilters : []
              | async
              | recursiveFilter: filterTerm
            )?.length +
              '/' +
              (total$ | async)
          }}
          {{ 'general.total' | translate }}
        </span>
      </div>

      <div class="btn-group ms-3" dropdown>
        <button
          class="btn btn-sm btn-white dropdown-toggle"
          type="button"
          dropdownToggle
          [style]="selectedFilters?.length ? 'border: 1px solid #377dff;' : ''"
        >
          <span>{{ 'general.filterBy' | translate }}</span>
        </button>

        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" sale="menu">
          <li *ngFor="let userFilter of filters">
            <button
              type="button"
              class="dropdown-item"
              (click)="onFilterByClicked(userFilter)"
            >
              <span
                [ngClass]="{
                  selected: selectedFilters?.includes(userFilter)
                }"
                >{{ 'saleModule.' + userFilter | translate }}
              </span>
            </button>
          </li>
        </ul>
      </div>

      <div class="btn-group ms-3" dropdown *ngIf="bulkActions?.length">
        <button
          class="btn btn-sm btn-white dropdown-toggle"
          type="button"
          dropdownToggle
        >
          {{ 'general.actions' | translate }}
        </button>

        <ul *dropdownMenu class="dropdown-menu" sale="menu">
          <li *ngFor="let bulkAction of bulkActions">
            <button
              type="button"
              class="dropdown-item"
              (click)="onClickBulkAction(bulkAction)"
            >
              {{ 'general.' + bulkAction | translate }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- End Row -->
</div>
<!-- End Header -->

<!-- Table -->
<div class="table-responsive">
  <table
    #dataTable="mfDataTable"
    [mfData]="
      tableData
        | getSaleTableData: selectedSaleIds : selectedFilters
        | async
        | recursiveFilter: filterTerm
    "
    [mfRowsOnPage]="25"
    class="table table-borderless table-striped table-hover table-nowrap"
  >
    <thead class="table-light">
      <tr>
        <th scope="col" style="width: 7%">
          <input
            (click)="onToggleAllChecked()"
            [checked]="allCheckedToggle"
            type="checkbox"
            class="form-check-input"
            attr.aria-label="{{ 'general.selectAll' | translate }}"
          />
        </th>
        <th scope="col" style="width: 10%">
          <mfDefaultSorter by="status">
            {{ 'general.status' | translate }}
          </mfDefaultSorter>
        </th>
        <th scope="col" style="width: 10%">
          <mfDefaultSorter by="id">
            {{ 'general.number' | translate }}
          </mfDefaultSorter>
        </th>
        <th scope="col" style="width: 15%">
          <mfDefaultSorter by="memberId">
            {{ 'memberModule.member' | translate }}
          </mfDefaultSorter>
        </th>
        <th scope="col" style="width: 20%">
          <mfDefaultSorter by="organizationId">
            {{ 'organizationModule.organization' | translate }}
          </mfDefaultSorter>
        </th>
        <th scope="col" style="width: 15%">
          <mfDefaultSorter by="date">
            {{ 'general.date' | translate }} / {{ 'general.time' | translate }}
          </mfDefaultSorter>
        </th>
        <th scope="col" style="width: 20%">
          <mfDefaultSorter by="total">
            {{ 'general.total' | translate }}
          </mfDefaultSorter>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let sale of dataTable.data; let i = index"
        class="cursor-pointer"
      >
        <td (click)="onCheckRow(sale)">
          <input
            [checked]="this.checkedIds.get(sale.id)"
            type="checkbox"
            class="form-check-input"
            attr.aria-label="{{ 'wcag.selectThis' | translate }}"
          />
        </td>
        <td>
          <span>
            <span
              [ngClass]="{
                'bg-soft-success':
                  (sale | saleFinalStatusCode) === saleStatusCode.DONE,
                'bg-soft-primary':
                  (sale | saleFinalStatusCode) === saleStatusCode.INFLIGHT,
                'bg-soft-secondary':
                  (sale | saleFinalStatusCode) === saleStatusCode.CANCELLED,
                'bg-soft-info':
                  (sale | saleFinalStatusCode) ===
                  saleStatusCode.PENDING_REQUIRED
              }"
              class="badge"
            >
              {{
                'saleModule.statusCode' + (sale | saleFinalStatusCode)
                  | translate
              }}
              <span *ngIf="sale.isCreditOfSaleId">
                - {{ 'saleModule.isCreditSale' | translate }}
              </span>
            </span>
          </span>
        </td>
        <td>
          <a [routerLink]="['/sales/', sale.id]" class="fw-bold">
            #{{ sale.id }}
          </a>
        </td>
        <td>
          <a [routerLink]="['/members/', sale.customerPersonId]">
            {{ sale.memberName }}
          </a>
        </td>

        <td>
          <a [routerLink]="['/organizations', sale.organizationId]">
            {{ sale.organization }}
          </a>
        </td>

        <td>
          <span>
            {{ sale.date }}
          </span>
        </td>
        <td>
          {{ sale.total | currency }}
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="6" class="pb-0">
          <mfBootstrapPaginator
            [rowsOnPageSet]="[25, 50, 100]"
          ></mfBootstrapPaginator>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
